import { __assign } from 'tslib';
import * as React from 'react';

var SvgArrowRight = function SvgArrowRight(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 120 120"
  }, props), React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h120v120H0z"
  }), React.createElement("path", {
    d: "M38.7 182.606a4.747 4.747 0 0 0-3.793-1.686c-1.686 0-2.948.317-3.9 1.686l-7.689 7.584a5.987 5.987 0 0 0-1.686 3.9 5.467 5.467 0 0 0 1.686 3.791l16.538 16.75-16.643 16.643a5.4 5.4 0 0 0-1.581 3.9 5.467 5.467 0 0 0 1.686 3.793l7.689 7.689a5.23 5.23 0 0 0 4 1.686 5.459 5.459 0 0 0 3.791-1.686l28.02-28.125a5.1 5.1 0 0 0 1.686-3.793 5.159 5.159 0 0 0-1.686-3.9Z",
    transform: "translate(17.954 -149.006)",
    style: {
      fill: "rgba(0,0,0,.3)"
    }
  }), React.createElement("path", {
    d: "M38.7 182.606a4.747 4.747 0 0 0-3.793-1.686c-1.686 0-2.948.317-3.9 1.686l-7.689 7.584a5.987 5.987 0 0 0-1.686 3.9 5.467 5.467 0 0 0 1.686 3.791l16.538 16.75-16.643 16.643a5.4 5.4 0 0 0-1.581 3.9 5.467 5.467 0 0 0 1.686 3.793l7.689 7.689a5.23 5.23 0 0 0 4 1.686 5.459 5.459 0 0 0 3.791-1.686l28.02-28.125a5.1 5.1 0 0 0 1.686-3.793 5.159 5.159 0 0 0-1.686-3.9Z",
    transform: "translate(17.954 -153.006)",
    style: {
      fill: "#afafaf"
    }
  }), React.createElement("path", {
    d: "M38.7 179.606a4.747 4.747 0 0 0-3.793-1.686c-1.686 0-2.948.317-3.9 1.686l-7.689 7.584a5.987 5.987 0 0 0-1.686 3.9 5.467 5.467 0 0 0 1.686 3.791l16.538 16.75-16.643 16.643a5.4 5.4 0 0 0-1.581 3.9 5.467 5.467 0 0 0 1.686 3.793l7.689 7.689a5.23 5.23 0 0 0 4 1.686 5.459 5.459 0 0 0 3.791-1.686l28.02-28.125a5.1 5.1 0 0 0 1.686-3.793 5.159 5.159 0 0 0-1.686-3.9Z",
    transform: "translate(17.954 -155.252)",
    style: {
      fill: "#fff"
    }
  }));
};

export { SvgArrowRight as default };